<template>
  <v-tooltip bottom>
    <template v-slot:activator="{ on }">
      <v-btn
        flat
        icon
        :color="color"
        v-on="on"
        @click="click()"
        :disabled="disabled"
        :to="to"
      >
        <v-icon>{{ icon }}</v-icon>
      </v-btn>
    </template>
    <span>{{ tooltip }}</span>
  </v-tooltip>
</template>

<script>
export default {
  props: {
    icon: String,
    tooltip: String,
    color: String,
    disabled: {
      type: Boolean,
      default: false
    },
    to: {
      type: Object,
      default: null
    }
  },
  methods: {
    click() {
      this.$emit("click");
    }
  }
};
</script>
